import api from "@/services/api";

// Get brands
export const getBrands = async (
  page,
  perPage,
  sortBy = "id.asc",
  searchQuery = ""
) => {
  try {
    const response = await api.get("/v1/admin/brands", {
      params: {
        sortBy,
        page,
        perPage,
        search: searchQuery,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching brands:", error);
    throw error;
  }
};

// Get brand by ID
export const getBrandById = async (id) => {
  try {
    const response = await api.get(`/v1/admin/brands/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching brand:", error);
    throw error;
  }
};

// Create brand
export const createBrand = async (brandData) => {
  try {
    const response = await api.post("/v1/admin/brands", brandData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating brand:", error);
    if (error.response) {
      console.error("Server response:", error.response.data);
      console.error("Status code:", error.response.status);
    }
    throw error;
  }
};

// Update brand
export const updateBrand = async (id, brandData) => {
  try {
    console.log("Updating brand with data:", brandData);

    const formData = new FormData();
    Object.keys(brandData).forEach((key) => {
      if (brandData[key] !== null && brandData[key] !== undefined) {
        formData.append(key, brandData[key]);
      }
    });

    const response = await api.put(`/v1/admin/brands/${id}`, formData);
    return response.data;
  } catch (error) {
    console.error("Error updating brand:", error);
    throw error;
  }
};

// Delete brand
export const deleteBrand = async (id) => {
  try {
    await api.delete(`/v1/admin/brands/${id}`);
    return id;
  } catch (error) {
    console.error("Error deleting brand:", error);
    throw error;
  }
};
